// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cbwWH","colMin":"styles_colMin__13vFp"};